import Client from '@/classes/Api/Client';

const state = {
  user: {},
  loading: false,
  authorized: false,
};

const getters = {
  fullName(state) {
    return state.user.full_name;
  },
  roles(state) {
    return state.user.roles;
  },
  hasRole: (state) => (role) => {
    if (typeof state.user.roles === 'undefined') {
      return false;
    }
    if (Array.isArray(role)) {
      for (let i in role) {
        if (state.user.roles.indexOf(role[i]) !== -1) {
          return true;
        }
      }
      return false;
    }
    return state.user.roles.indexOf(role) !== -1;
  },
};

const mutations = {
  setProfile(state, data) {
    state.user = data;
  },
  setAuthorizedStatus(state, status) {
    state.authorized = !!status;
  },
  loadingStatus(state, status) {
    state.loading = !!status;
  },
};

const actions = {
  loadProfile(context) {
    return Client.getProfile().then((response) => {
      context.commit('setProfile', response.data);
      context.commit('setAuthorizedStatus', true);
    });
  },
  logout(context) {
    return Client.logout().then(() => {
      context.commit('setProfile', {});
      context.commit('setAuthorizedStatus', false);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
